import { parseTheme } from 'mol-ui';
import styled from 'styled-components';

export const Container = styled.div`
    background: #DDDDDD;
    height: 100vh;
    @media(max-width: 600px) {
        background: #EEEEEE;
    }
`;

export const ErrorMessage = styled.div`
    ${ parseTheme('color', 'dangerColor') }
    font-size: 17px;
    margin-bottom: 30px;
`;

export const Link = styled.div`
    bottom: -100px;
    color: #444444;
    cursor: pointer;
    position: relative;
    text-align: center;
    width: 100%;
`;

export const StatusContainer = styled.div`
    align-items: center;
    display: flex;
    height: 100px;
    justify-content: center;
    position: relative;
    top: 90px;
    width: 100%;
`;

export const Subtitle = styled.div`
    color: #444444;
    font-size: 13px;
    position: relative;
    top: 60px;
`;

export const TextContainer = styled.div`
    background: #FFFFFF;
    border: solid 3px;
    ${ parseTheme('border-color', 'primaryColor') }
    border-radius: 10px;
    box-shadow: #AAAAAA 2px 2px;
    height: 350px;
    left: calc(50% - 300px);
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
    text-align: center;
    top: calc(50vh - 175px);
    width: 600px;
    @media(max-width: 600px) {
        box-shadow: none;
        left: 0px;
        position: relative;
        top: calc(50% - 200px);
        width: 100%;
    }
`;

export const Title = styled.div`
    ${ parseTheme('color', 'primaryColor') }
    font-size: 30px;
    font-weight: bold;
    position: relative;
    top: 40px;
`;

export const Version = styled.div`
    bottom: 0px;
    font-size: 12px;
    left: 5px;
    position: fixed;
`;
